module.exports = __webpack_public_path__ + "img/ExportButton2.69aacc34.png";